import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';
import { benchmarkActions } from '~/behaviors/actions/benchmark.actions';
import { handleUnsafeOptionalChaining } from '~/tools/lint/handleUnsafeOptionalChaining';

const reset = () => defaultState;

const defaultState = {};

const replaceAttributes = (state, action) => {
  const benchmarkAttributes = action?.payload?.entities?.benchmarkAttributes;

  return { ...benchmarkAttributes };
};

const mergeAttributeAltNames = (state, action) => {
  const { benchmarkAttributeName, benchmarkAttributeValueId, names } = handleUnsafeOptionalChaining(action?.payload);
  if (!benchmarkAttributeValueId) return;
  state[benchmarkAttributeName]?.values?.every((value, index) => {
    if (value.id === benchmarkAttributeValueId) {
      names.forEach((name) => state[benchmarkAttributeName]?.values[index].altNames.push(name));
      return false;
    }
    return true;
  });
};

const updateAttributeAltNames = (state, action) => {
  const { benchmarkAttributeName, newBenchmarkAttributeValueId, oldBenchmarkAttributeValueId, name } =
    handleUnsafeOptionalChaining(action?.payload);
  if (!name) return;
  state[benchmarkAttributeName]?.values?.every((value, index) => {
    let addNewName = false,
      removeOldName = false;
    if (value.id === newBenchmarkAttributeValueId) {
      state[benchmarkAttributeName]?.values[index].altNames.push(name);
      addNewName = true;
    }
    if (value.id === oldBenchmarkAttributeValueId) {
      const nameIndex = state[benchmarkAttributeName]?.values[index].altNames.indexOf(name);
      state[benchmarkAttributeName]?.values[index].altNames.splice(nameIndex, 1);
      removeOldName = true;
    }
    return !addNewName || !removeOldName;
  });
};

const benchmarkAttributes = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(benchmarkActions.fetchAllBenchmarkAttributes.fulfilled, replaceAttributes);

  builder.addCase(benchmarkActions.mapValuesToBenchmarkAttributeValue.fulfilled, mergeAttributeAltNames);

  builder.addCase(benchmarkActions.updateValueToBenchmarkAttrValueMapping.fulfilled, updateAttributeAltNames);
});

export { benchmarkAttributes };
